





























































import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  data() {
    return {
      error: false,
      confirming: false,
      removing: false
    };
  },

  methods: {
    async wipeAvailabilities() {
      this.error = false;
      this.removing = true;

      try {
        await axios.delete("/ajax/availabilities");

        this.confirming = false;

        this.$emit("wiped");
      } catch {
        this.error = true;
      } finally {
        this.removing = false;
      }
    }
  }
});
